import { Component, ViewChild } from '@angular/core';
import { ModalController, NavController, NavParams, Slides, ViewController } from 'ionic-angular';
import { WpProvider } from '../../providers/wp/wp';
import { IPhcGalleryAlbum, PhcApp, PhcAppGallery } from '../../classes/phc-app/phc-app';

/**
 * Generated class for the GalleryAlbumModal page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-gallery-album',
  templateUrl: 'gallery-album-modal.html',
})
export class GalleryAlbumModal {

  @ViewChild('slides') slides: Slides;

  album: IPhcGalleryAlbum;
  size = window['innerWidth'] / 3;
  showFull = true;
  currentImage: PhcAppImage = null;
  loadedImages = [];

  constructor(params: NavParams, private wp: WpProvider, private viewCtrl: ViewController) {
    this.album = wp.app.getGallery(params.get('galleryId')).albums[params.get('albumIndex')];
    this.currentImage = this.album.images[0];
    console.log(this.slides);
  }

  isLoaded(src) {
    return this.loadedImages.indexOf(src) > -1;
  }

  loadOnShow(image: PhcAppImage) {
    const src = image.sizes.medium;
    if(this.isLoaded(src)) {
      return src;
    }
    if (this.showFull && this.currentImage.sizes.medium === src) {
      this.loadedImages.push(src);

      return src;
    }
  }

  updateCurrentImage($event) {
    this.currentImage = this.album.images[this.slides.getActiveIndex()];
    const currentIndex = this.album.images.indexOf(this.currentImage);

    const preloadImages = [
      currentIndex - 1,
      currentIndex - 2,
      currentIndex + 1,
      currentIndex + 2
    ].map(ind => this.album.images[ind]).filter(img => img && img.sizes).map(img => img.sizes.medium);
    preloadImages.forEach(src => {
      if(this.loadedImages.indexOf(src) === -1) {
        this.loadedImages.push(src);
      }
    });
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  openFullScreen(image: PhcAppImage) {
    console.log('showing full', image);
    this.currentImage = image;
    this.showFull = true;
    this.slides.slideTo(this.album.images.indexOf(image));
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GalleryAlbumModal');
  }

}



// WEBPACK FOOTER //
// ./src/pages/gallery/gallery-album-modal.ts